module.exports = __webpack_public_path__ + "static/media/ic_搜索_默认.e328c587.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_搜索_默认.svg
// module id = 246
// module chunks = 0